module.exports = __webpack_public_path__ + "assets/img/Home.298ed9af-ps.jpg";